<template>
  <a-row>
    <a-col span="12">
      <div id="maker" style="width: 375px;margin: 0 auto;border: 1px solid #d8d8d8;height: 667px;overflow-y: auto;"></div>
    </a-col>
    <a-col span="12">
      <CommonPermissions :p="$permissions.TEXTBOOK.UPDATE">
        <a-button @click="save">保存</a-button>
      </CommonPermissions>
    </a-col>
    <LessonHeader1 ref="lessonHeader1" @ok="insertContent"/>
    <Gallery1 ref="gallery1" @ok="insertContent"/>
    <Thumb1 ref="thumb1" @ok="insertContent"/>
    <Bubble1 ref="bubble1" @ok="insertContent" @replace="replaceContent"/>
  </a-row>
</template>

<script>
const OSS = require('ali-oss')
import LessonHeader1 from './templates/LessonHeader1.vue'
import Thumb1 from './templates/Thumb1.vue'
import Gallery1 from './templates/Gallery1.vue'
import Bubble1 from './templates/Bubble1.vue'
import OssApi from '../../../api/src/oss/api/OssApi'
import TextBookApi from '@/api/src/textbook/api/TextBookApi'
import CommonPermissions from '@/components/CommonPermissions'
const ossApi = new OssApi()
const textBookApi = new TextBookApi()

export default {
  name: 'textbookMaker',
  data() {
    return {
      textbook: {},
      unit: {},
      lesson: {},
      defaultContent: '',
      currentEl: undefined
    }
  },
  components: {
    CommonPermissions,
    LessonHeader1,
    Gallery1,
    Thumb1,
    Bubble1
  },
  async created() {
    let {textbookId, unitId, lessonId} = this.$route.params;
    console.log({textbookId, unitId, lessonId})
    let textbook = await textBookApi.findTextBookById(textbookId)
    let unit = await textBookApi.getUnit(unitId)
    let lesson = await textBookApi.getLesson(lessonId)
    console.log(textbook)
    console.log(unit)
    console.log(lesson)
    this.$store.commit('textbookMaker/changeLesson', {textbook, unit, lesson})
    this.textbook = textbook
    this.unit = unit
    this.lesson = lesson
    let defaultContent = await this.getDefaultContent()
    console.log(defaultContent)
    this.defaultContent = defaultContent
    tinymce.activeEditor.setContent(defaultContent);
  },
  mounted() {
    tinymce.init({
      selector: '#maker',
      // paste_block_drop: false,
      // paste_merge_formats: false,
      // paste_postprocess: () => {
      //   console.log('paste')
      // },
      // valid_elements: false,
      // valid_children: '+span[span],+span[div]',
      // end_container_on_empty_block: false,
      language:'zh-Hans',
      resize: false,
      width: '375',
      height: '667',
      indentation: '2em',
      menubar: 'format headerTemplate galleryTemplate interactiveTemplate',
      menu: {
        format: { title: 'Format', items: 'bold italic underline strikethrough codeformat | align | forecolor backcolor | removeformat' },
        headerTemplate: { title: '头结构', items: 'lessonHeader1' },
        // contentTemplate: { title: '内容结构', items: 'whiteCard' },
        galleryTemplate: { title: '图片', items: 'thumb1 gallery1' },
        interactiveTemplate: { title: '交互', items: 'bubble1' },
      },
      toolbar: 'bold italic underline strikethrough | alignleft aligncenter alignright alignjustify | ' +
      'outdent indent | forecolor backcolor',
      // content_css: '/style/textbook/base.css,/style/textbook/mobile.css',
      content_css: '/style/textbook/content.css',
      body_class: 'fm_content',
      init_instance_callback: (editor) => {
        console.log(this.defaultContent)
        editor.setContent(this.defaultContent)
      },
      setup: (editor) => {
        editor.ui.registry.addMenuItem('lessonHeader1', {
          text: '节头1',
          onAction: () => {
            this.$refs.lessonHeader1.open()
          }
        });
        editor.ui.registry.addMenuItem('gallery1', {
          text: '画廊',
          onAction: () => {
            this.$refs.gallery1.open()
          }
        });
        editor.ui.registry.addMenuItem('thumb1', {
          text: '单图',
          onAction: () => {
            this.$refs.thumb1.open()
          }
        });
        editor.ui.registry.addMenuItem('bubble1', {
          text: '气泡',
          onAction: () => {
            this.$refs.bubble1.open()
          }
        });
        // editor.ui.registry.addMenuItem('whiteCard', {
        //   text: '白底卡片',
        //   onAction: () => {
        //     tinymce.activeEditor.selection.setContent('<div class="fm_white_card_content">'+tinymce.activeEditor.selection.getContent()+'</div>');
        //   }
        // });
        editor.on('SetContent', function (e) {
          console.log('SetContent')
          console.log(e)
        });
        editor.on('dblclick', (e) => {
          console.log('Element clicked:', e);
          this.currentEl = e
          let componentName = e.target.dataset.name
          let json = e.target.dataset.json
          console.log(componentName)
          console.log(json)
          console.log(Bubble1.name)
          switch (componentName) {
            case Bubble1.name:
              console.log(11)
              this.$refs.bubble1.setData(json)
              this.$refs.bubble1.open()
              break
            case LessonHeader1:
              console.log(22)
              break
          }
        });
      }
    });
    this.init()
  },
  methods: {
    async init() {
    },
    getDefaultContent() {
      return new Promise((resolve, reject) => {
        var httpRequest = new XMLHttpRequest()
        httpRequest.open('GET', `https://bookpreview.aefree.com/textbook/${this.textbook.id}/${this.unit.folderName}/${this.lesson.filePath}`)
        httpRequest.onreadystatechange = function() {
          if(httpRequest.readyState == 4 && httpRequest.status == 200){
            let content = httpRequest.responseText
            let defaultContent = content.replace(`<!DOCTYPE html><html lang="en"><head><meta charset="utf-8"><meta http-equiv="X-UA-Compatible" content="IE=edge"><meta name="viewport" content="width=device-width,initial-scale=1.0"><link rel="stylesheet" href="../META-INF/css/content.css"></link><title>模板界面</title></head><body class="fm_content">`, '').replace('</body></html>', '')
            resolve(defaultContent)
          }
        }
        httpRequest.send()
      })
    },
    insertContent({content}) {
      console.log(content)
      tinymce.activeEditor.insertContent(content, { format: 'html' });
      // tinymce.activeEditor.execCommand('mceInsertContent', true, content)
    },
    replaceContent({content}) {
      console.log(this.currentEl)
      console.log(tinymce.activeEditor.dom.doc.querySelector('#aaa'))
      var parser = tinymce.html.DomParser({validate: false}, tinymce.activeEditor.schema);
      var rootNode = parser.parse(content);
      console.log(rootNode)
      tinymce.activeEditor.dom.replace(rootNode, 'aaa', false)
      // console.log(tinymce.activeEditor.dom.select('#aaa'))
      // tinymce.activeEditor.dom.setHTML(tinymce.activeEditor.dom.select('#aaa'), content)
    },
    async save() {
      let content = tinymce.activeEditor.getContent({ format: 'html' })
      console.log(content)
      content = `<!DOCTYPE html><html lang="en"><head><meta charset="utf-8"><meta http-equiv="X-UA-Compatible" content="IE=edge"><meta name="viewport" content="width=device-width,initial-scale=1.0"><link rel="stylesheet" href="../META-INF/css/content.css"></link><title>模板界面</title></head><body class="fm_content">` + content + `</body><script src="../META-INF/js/global.v2.js"><\/script></html>`
      let path = `textbook/${this.textbook.id}/${this.unit.folderName}/`
      let res = await ossApi.getStsAkTextbookEditor(path)
      console.log(res)
      let region = res.endpoint;
      let fKey = region.indexOf('//') + 2;
      let lKey = region.indexOf('.');
      let client = new OSS({
        region: region.substring(fKey,lKey),
        accessKeyId: res.accessKeyId,
        accessKeySecret: res.accessKeySecret,
        stsToken: res.securityToken,
        bucket: res.bucketName,
      })
      let blob = new Blob([content], {
        type: 'text/html; charset=UTF-8'
      })
      const result = await client.put(`${path}${this.lesson.filePath}`, blob)
      console.log(result)
    },
  }
}
</script>

<style>

</style>